import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { DTODiffusionModelsTableBase } from '@shared/dto/+diffusion_model/_base/table/dto_diffusion_model_table_base';
import { DTODiffusionModelsTablePageSettingsBase } from '@shared/dto/+diffusion_model/_base/table/dto_diffusion_models_table_page_settings_base';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EDiffusionModelsFilterType } from '../enums/e_page_diffusion_models_filter_type';
import { DiffusionModelsFilterListModelTypeItem } from './diffusion_models_filter_list_model_type_item';

interface Props {
  current_table: DTODiffusionModelsTableBase;
  current_table_page_settings: DTODiffusionModelsTablePageSettingsBase;
  on_value_change: (value: string) => void;
}

export function DiffusionModelsFilterListModelType({ current_table, current_table_page_settings, on_value_change }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const [value_selected, set_value_selected] = useState(
    current_table_page_settings.is_filter_type_all() ? EDiffusionModelsFilterType.ALL : current_table_page_settings.filter_type,
  );

  /*
   * EVENTS
   */

  function on_value_change_internal(value: string) {
    set_value_selected(value);

    on_value_change(value);
  }

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  function render_items() {
    const items = Object.values(EDiffusionModelsFilterType);

    return items.map(item => {
      return (
        <DiffusionModelsFilterListModelTypeItem key={item} on_value_change={on_value_change_internal} {...{ value: item, value_selected, current_table }} />
      );
    });
  }

  /*
   * HTML
   */

  return (
    <div className={`w-full flex flex-col`}>
      <div className="h-[40px] bg-bar px-2 text-page-foreground flex items-center justify-start">{t(i18n_page_diffusion_models.list.model_type.title)}</div>
      <div className={`flex flex-col w-full bg-component overflow-auto pt-1  px-2  `}>{render_items()}</div>
    </div>
  );
}
